import { IconEllipsisHorizontal } from "@/assets/icons/geist/IconEllipsisHorizontal";
import { Button } from "@/components/flexkit/Button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@/components/podkit/dropdown/DropDown";
import { cn } from "@/components/podkit/lib/cn";
import type React from "react";
import { type FC, type PropsWithChildren } from "react";

const buttonClassName = cn(
    "flex rounded-md bg-transparent p-1 hover:bg-surface-hover data-[state=open]:bg-surface-hover",
);

export const DropdownActions: FC<
    {
        button?: React.ReactNode;
        triggerTestId?: string;
        open?: boolean;
        onOpenChange?: (open: boolean) => void;
        align?: React.ComponentPropsWithoutRef<typeof DropdownMenuContent>["align"];
        side?: React.ComponentPropsWithoutRef<typeof DropdownMenuContent>["side"];
        contentClassName?: string;
    } & PropsWithChildren
> = ({ button, children, triggerTestId, open, onOpenChange, align = "end", side, contentClassName }) => {
    return (
        <DropdownMenu open={open} onOpenChange={onOpenChange}>
            {/* Todo: finally move the styles out of index.css */}
            <DropdownMenuTrigger data-testid={triggerTestId} asChild>
                {button ? (
                    button
                ) : (
                    <Button variant="ghost" className={buttonClassName} aria-label="More actions">
                        <IconEllipsisHorizontal size="base" className="size-6 rounded-md p-0.5 text-content-primary" />
                    </Button>
                )}
            </DropdownMenuTrigger>
            <DropdownMenuContent align={align} side={side} className={cn("focus-visible:ring-0", contentClassName)}>
                {children}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
